import { Box } from '@mui/material';
import Popover from '@mui/material/Popover';
import * as React from 'react';

import { IBasicPopoverProps } from './BasicPopover.types';

export default function BasicPopover({
  children = 'Open Popover',
  element,
  open = true,
  onChange,
  sx,
}: IBasicPopoverProps) {
  const [anchorEl, setAnchorEl] = React.useState<HTMLDivElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
    onChange?.(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
    onChange?.(false);
  };

  const isOpen = Boolean(anchorEl) && open;
  const id = isOpen ? 'simple-popover' : undefined;

  return (
    <>
      <Box
        component="div"
        aria-describedby={id}
        onClick={handleClick}
        sx={{ height: '100%', width: '100%', ...sx }}
      >
        {children}
      </Box>
      <Popover
        id={id}
        open={isOpen}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        sx={{ height: '100%' }}
        slotProps={{ paper: { sx: { height: '100%' } } }}
      >
        {element}
      </Popover>
    </>
  );
}
